import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { getFetchBaseQueryHeader } from '../getFetchBaseQuery';

export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: getFetchBaseQueryHeader({
        accept: 'application/json',
    }),
    endpoints: (build) => ({}),
});
